var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"geographics-card"},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Geographical Information")]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',[_c('div',{staticClass:"map-container",attrs:{"id":"userMap"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }